<!-- Component for rendering a list item 'slide' with text content and a background image -->
<template>
	<div class="fluid relative flex max-h-dvh w-full items-center justify-center">
		<div class="relative z-10 max-w-3xl text-center">
			<div
				v-for="slide in slide.content"
				:key="slide._uid"
			>
				<component
					class="p-8 text-left"
					:is="slide.component"
					:blok="slide"
				/>
			</div>
		</div>
		<SbImage
			:blok="slide.image"
			class="absolute -left-20 z-0 w-3xl rounded-full bg-indigo-50 object-cover opacity-15"
			alt="Slide image"
		/>
	</div>
</template>

<script setup lang="ts">
import SbImage from '@/components/blocks/SbImage.vue'
import type { ListItemTextSlideStoryblok } from '@/sbTypes'

defineProps<{ slide: ListItemTextSlideStoryblok }>()
</script>
